var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgReportIcon = function SvgReportIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.898 3.692h-6.014a.41.41 0 0 0-.41.41v23.795c0 .227.183.41.41.41h6.014a.41.41 0 0 0 .41-.41V4.103a.41.41 0 0 0-.41-.41ZM19 9.846h-6.013a.41.41 0 0 0-.41.41v17.641c0 .227.183.41.41.41h6.013a.41.41 0 0 0 .41-.41v-17.64a.41.41 0 0 0-.41-.41ZM4.103 16h6.013a.41.41 0 0 1 .41.41v11.487a.41.41 0 0 1-.41.41H4.103a.41.41 0 0 1-.41-.41V16.411a.41.41 0 0 1 .41-.41Z",
    fill: "#FCFAF8"
  })));
};

export default SvgReportIcon;